module.exports = __webpack_public_path__ + "static/media/Store-2021-2022-bundle-banner3b-SFW.a1d33951.jpg";